import { FormatMessageType } from '@hooks/useValidation';
import { EMAIL, MAX_FIELD, MIN_FIELD, REQUIRED_FIELD } from '@utils/validation/validation.constant';
import Yup from '@utils/validation/yup-extended';

export function organizationSchemaValidation(formatMessage: FormatMessageType) {
  return Yup.object({
    name: Yup.string().required(
      formatMessage({ id: REQUIRED_FIELD }, { field: formatMessage({ id: 'components.organizations.general.name' }) }),
    ),
    email: Yup.string()
      .email(formatMessage({ id: EMAIL }))
      .required(
        formatMessage(
          { id: REQUIRED_FIELD },
          { field: formatMessage({ id: 'components.organizations.general.email' }) },
        ),
      ),

    organizationParameter: Yup.object({
      enableLadAlerts: Yup.boolean(),
      enableUtmAlerts: Yup.boolean(),
      enableTechAlerts: Yup.boolean(),
      enablePeriAlerts: Yup.boolean(),
      enableProcedureAutoArchive: Yup.boolean(),
      expiredNotificationsTtl: Yup.number()
        .moreThan(
          0,
          formatMessage(
            { id: MIN_FIELD },
            { value: 0, field: formatMessage({ id: 'components.organizations.settings.procedureAutoArchive' }) },
          ),
        )
        .lessThan(
          525960,
          formatMessage(
            { id: MAX_FIELD },
            {
              value: 525960,
              field: formatMessage({ id: 'components.organizations.settings.procedureAutoArchive' }),
            },
          ),
        )
        .required(
          formatMessage(
            { id: REQUIRED_FIELD },
            { field: formatMessage({ id: 'components.organizations.settings.procedureAutoArchive' }) },
          ),
        ),
    }),
  });
}
